import BopisController from './lib/BopisController';
const controller = new BopisController();

export {
	controller as BopisController
};
